import flatMap = require('lodash/flatMap');
import { IPackage, IZone } from '../custom/classes/production';


export function getPackagePerformances(pkg: IPackage) {
    const allPerf = flatMap(pkg.performanceGroupDetails
        .map(group => flatMap(group.appProductions.map(prod => prod.performances))));
    return allPerf;
}